import './Work.scss'
import experiences from './experiences.js'
import { motion } from 'framer-motion'

const Work = () => {
  return (
    <div className='work' id='work'>
      <h1>Experiences</h1>
      <div className='experience-main'>
        <a
          style={{ textDecoration: 'none', color: 'inherit' }}
          href='https://www.onesecuritiesbd.com/'
          target='_blank'
        >
          <img src="Assets/oneSecurities.png" alt='ONE Securities Ltd.' />
        </a>
        <a 
          style={{flexDirection: 'column', textDecoration: 'none', color: 'inherit'}}
          href='https://www.onesecuritiesbd.com/'
          target='_blank'>

          <h2 style={{ marginTop: 20, textAlign: 'center' }}>
            Senior Officer & Branch In-Charge
          </h2>
          <p style={{ marginTop: 10, color: 'grey', textAlign: 'center' }}>
            ONE Securities Ltd.(Nikunja Branch)
          </p>
          <p style={{ marginTop: 10, textAlign: 'center' }}>
            27th June 2021 - Present
          </p>
          <br />
          <p style={{ textAlign: 'center' }}>
            DSE Tower (Level 9),
            <br />
            Room-165, Plot-46, Road-21,
            <br />
            Nikunja - 2, Dhaka - 1229
          </p>
        </a>
        
      </div>
      <div className='experience-wrapper'>
        {experiences.map((work, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            animate={{ borderRadius: 15}}
            className='experience-item'
            key={index}
          >
            <>
              <img src={work.logo} alt={work.company} />
              <h2 style={{ marginTop: 20, textAlign: 'center' }}>
                {work.position}
              </h2>
              <p style={{ marginTop: 10, color: 'grey', textAlign: 'center' }}>
                {work.company}
              </p>
              <p style={{ marginTop: 10, textAlign: 'center' }}>{work.time}</p>
            </>
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default Work
